export const educations = [
    {
        data: "18 January 2022 - 20 July 2022",
        name: "EACAMP",
        about: "Frontend Developer Bootcamp",
        skills: ["HTML","CSS","Bootstrap","JavaScript","jQuery","React","Redux Toolkit","Redux","FireBase"]
    },
    {
        data: "2018 - 2022",
        name: "Bachelors",
        about: "I have completed my bachelor's degree in Computer Engineer at UTECA"
    },
    {
        data: "2022 - 2024",
        name: "Master",
        about: "I am studying cyber security at the master's level of AzTU (SABAH)."
    }
]

export const experience = [
    {
        data: "23 July 2022 - 20 April 2023",
        name: "FreeLancer",
        about: "Front end developer FreeLancer in EACAMP",
        skills: ["HTML","CSS","Bootstrap","JavaScript","Ajax","jQuery","Fetch",
        "React","Redux Toolkit","Redux","FireBase", "MUI", "Git", "Github"]
    },
    {
        data: "1 March 2023 - 20 November 2023",
        name: "StartUp",
        about: "Front end developer Remote in Insightify",
        skills: ["TypeScript","Tailwind CSS","React","Next.js","Redux Toolkit","FireBase", "MUI", "Git", "Github"]
    },
]